/** Espectro simulado no formato getByteFrequencyData — a fala da Greening usa o mesmo desenho do mic. */

const BANDS = 256;

let level = 0;
let pulse = 0;
let active = false;
let chunkWeight = 0.55;
let lastTick = 0;
const bands = new Uint8Array(BANDS);

function voiceProfile(index: number): number {
  const x = index / (BANDS - 1);
  // Mais energia no médio (voz), menos nas bordas — perfil próximo ao mic.
  const mid = Math.exp(-Math.pow((x - 0.28) / 0.22, 2));
  const body = Math.exp(-Math.pow((x - 0.48) / 0.35, 2)) * 0.65;
  const air = Math.exp(-Math.pow((x - 0.72) / 0.2, 2)) * 0.35;
  return Math.min(1, mid + body + air);
}

function rewriteBands(now: number) {
  const shimmer = 0.85 + 0.15 * Math.sin(now * 0.017);
  const mix = Math.min(1, Math.max(0, level + pulse));
  for (let i = 0; i < BANDS; i += 1) {
    const wobble = 0.75 + 0.25 * Math.sin(now * 0.011 + i * 0.09);
    const value = voiceProfile(i) * mix * shimmer * wobble * 255;
    bands[i] = Math.max(0, Math.min(255, Math.round(value)));
  }
}

export function startChunk(text: string) {
  const len = (text || '').trim().length;
  chunkWeight = Math.min(1, 0.45 + Math.min(len, 80) / 120);
  active = true;
  level = Math.max(level, 0.35 * chunkWeight);
  pulse = Math.max(pulse, 0.55);
  lastTick = performance.now();
  rewriteBands(lastTick);
}

export function pulseBoundary() {
  if (!active) return;
  pulse = Math.min(1, pulse + 0.55 * chunkWeight);
}

export function endChunk() {
  active = false;
  pulse *= 0.35;
}

export function resetSpeechBands() {
  active = false;
  level = 0;
  pulse = 0;
  chunkWeight = 0.55;
  bands.fill(0);
}

export function tick(now = performance.now()) {
  const dt = lastTick ? Math.min(0.05, (now - lastTick) / 1000) : 0.016;
  lastTick = now;
  if (active) {
    const target = 0.55 * chunkWeight + 0.2 * Math.sin(now * 0.012);
    level += (target - level) * Math.min(1, dt * 10);
    pulse *= Math.exp(-dt * 6);
  } else {
    level *= Math.exp(-dt * 8);
    pulse *= Math.exp(-dt * 10);
  }
  rewriteBands(now);
}

export function fillFrequencyData(out: Uint8Array) {
  tick();
  const n = Math.min(out.length, bands.length);
  for (let i = 0; i < n; i += 1) out[i] = bands[i];
  for (let i = n; i < out.length; i += 1) out[i] = 0;
}
